module.exports = __webpack_public_path__ + "static/media/zapier.3ad9c9b3.svg";